import PropTypes from 'prop-types';
import React from 'react';
import { EmptyInteractions } from './EmptyInteractions';
import { StructuredInteractionCard } from './StructuredInteractionCard';
import { StructuredInteractionsForm } from './form/StructuredInteractionsForm';

export function StructuredInteractionsList({
  interactions,
  clickedIdx,
  onEdit,
  onCloseEdit,
}) {
  if (!interactions.length) {
    return <EmptyInteractions />;
  }

  return (
    <div>
      {interactions.map((interaction, idx) => (
        clickedIdx === idx ? (
          <StructuredInteractionsForm
            key={interaction.id}
            isEditing
            interaction={interaction}
            onClose={onCloseEdit}
          />
        ) : (
          <StructuredInteractionCard
            key={interaction.id}
            interaction={interaction}
            onEdit={() => onEdit(idx)}
          />
        )
      ))}
    </div>
  );
}

StructuredInteractionsList.propTypes = {
  interactions: PropTypes.arrayOf(PropTypes.object),
  clickedIdx: PropTypes.number,
  onEdit: PropTypes.func.isRequired,
  onCloseEdit: PropTypes.func.isRequired,
};

StructuredInteractionsList.defaultProps = {
  interactions: [],
  clickedIdx: undefined,
};
